/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Assesment In Psychology List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './NursingEducationListView';

export const mapStateToPropsNursingEducationList = mapStateToProps;
export const mapDispatchToPropsNursingEducationList = mapDispatchToProps;

export default connect(
  mapStateToPropsNursingEducationList,
  mapDispatchToPropsNursingEducationList
)(View);
